(() => {
  var t = {};
  Shopify.theme.jsVideo = {
    init: function (t) {
      Shopify.theme.jsVideo = $.extend(this, Shopify.theme.getSectionData(t));
      let e = t.find("[data-video-element]"),
        o = t.find(".plyr--paused.plyr--video .plyr__control--overlaid"),
        i = t.find("[data-play-button]"),
        a = t.find("[data-video-text-container]"),
        n = t.find("[data-image-element]");
      this.iframe_video || this.html5_video
        ? this.loadVideo(e, o, i, a, n)
        : n.show();
    },
    loadVideo: function (t, e, o, i, a) {
      // let n = new Plyr(`.video-${this.id}`, {
      //   controls: videoControls,
      //   loop: { active: this.autoloop },
      //   fullscreen: { enabled: !0, fallback: !0, iosNative: !0 },
      //   storage: { enabled: !1 },
      // });
      let n = new Plyr(`.video-${this.id}`, {
  controls: videoControls,
  loop: { active: this.autoloop },
  fullscreen: { enabled: false }, // Disable fullscreen button
  iosNative: false,               // Disable iOS native fullscreen behavior
  playsinline: true,              // Ask browsers to play inline
  storage: { enabled: false },
});
      (n.muted = this.mute),
        (n.ratio = this.aspect_ratio),
        this.autoplay
          ? ((n.autoplay = !0), a.hide(), i.hide(), t.show())
          : this.poster
          ? (t.hide(), a.show(), i.show())
          : (a.hide(), t.show(), i.show()),
        this.button &&
          o.on("click", () => {
            n.play();
          }),
        this.button ||
          i.on("click", () => {
            n.play();
          }),
        !isScreenSizeLarge() &&
          t.parents(".mobile-text--below-media") &&
          a.on("click", () => {
            n.play();
          }),
        n.on("ready", function (i, a) {
          o && !isScreenSizeLarge() && t.parents(".mobile-text--below-media")
            ? e.show()
            : o
            ? e.hide()
            : e.show();
        }),
        n.on("play", function (e, o) {
          t.show(), a.hide(), i.hide();
        }),
        n.on("pause", function (t, i) {
          o || e.show();
        });
    },
    unload: function (t) {
      let e = t.find("[data-play-button]"),
        o = t.find("[data-video-text-container]");
      e.off(), o.off();
    },
  };
})();
